// Trim URL parameters from Navigation links
export const trimParams  = (route) => {

	// Console logging flag
	const logToConsole = false;

	// TODO: Make output a variable; move logging condition to bottom of function and log output too
	// Console logging
	if (logToConsole) {
		console.log(
			'%c trimParams', 'font-weight: bold; color: none',
			'\n' + ' - route.typeof:', typeof route + '\n',
			{ route }
		);
	}

	let str = route;
	let n = str.indexOf('/:');
	if (n > -1) {
		return str.substring(0, n);
	} else {
		return str;
	}
};
